// File: js/shared/extensions/reference-create.js
//
// Initialization-only module for reference sections.
// Click/reorder/delete handling lives in `blockEventBus.js` (delegated
// globally, bound once). This file only registers the factory used by the
// bus in upload mode and imports the bus so it self-inits.

import { register } from '../events/blockFactoryRegistry.js';
import '../events/blockEventBus.js';
import { i18n } from '../utils/config.js';

register('references', (section, blockName, _type, index) => {
  const isEditMode = section.dataset.mode === 'edit';
  const showDesc = section.dataset.showDescription === 'true';
  return createReferenceBlock({ blockName, index, isEditMode, showDesc });
});

// Kept for symmetry with the other extensions; safe to call repeatedly.
export function setupReferenceBlocks() {
  // Nothing to per-block init — references are plain text inputs.
}

function createReferenceBlock({ blockName, index, isEditMode = false, showDesc = false }) {
  const prefix = `${blockName}[${index}]`;

  const ajaxAttrs = (field) => {
    if (!isEditMode) return '';
    return (
      ' data-ajax-oninput="true"' +
      ' data-name="editInput"' +
      ` data-block-name="${blockName}"` +
      ` data-index="${index}"` +
      ` data-field="${field}"`
    );
  };

  const descriptionHtml = showDesc
    ? `<input type="text" name="${prefix}[description]" placeholder="${i18n('block.reference.description_placeholder')}"${ajaxAttrs('description')}>`
    : '';

  return `
    <div class="block reference-block">
      <div class="block-header">
        <span class="block-label">${i18n('block.upload_label.reference')}</span>
        <div class="block-actions">
          <button type="button" data-action="up"     title="${i18n('block.action.move_up')}">↑</button>
          <button type="button" data-action="down"   title="${i18n('block.action.move_down')}">↓</button>
          <button type="button" data-action="delete" title="${i18n('block.action.delete')}">✕</button>
        </div>
      </div>
      <div class="reference-fields">
        ${descriptionHtml}
        <input type="text" name="${prefix}[label]" placeholder="${i18n('block.reference.name_placeholder')}"${ajaxAttrs('name')}>
        <input type="url"  name="${prefix}[link]"  placeholder="${i18n('block.reference.link_placeholder')}"${ajaxAttrs('link')}>
      </div>
      <input type="hidden" name="${prefix}[type]" value="reference">
    </div>
  `;
}
